var rtlStyles = {"rtl":"lwA2x","ltr":"_8lNYy"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-3ce60dde.js.map
